type DeepAnalysisResultProps = {
    userRequestId: string;
    result: string;
};

class DeepAnalysisResult {
    userRequestId: string;

    result: string;

    constructor({ userRequestId, result }: DeepAnalysisResultProps) {
        this.userRequestId = userRequestId;
        this.result = result;
    }
}

export default DeepAnalysisResult;
